import { nanoid } from 'nanoid'
import { create } from 'zustand'

export const newClientId = () => `msg-${nanoid(6)}`

const coerceClientId = project =>
  project.clientId ?? project.id ?? newClientId()

const isLoginRequiredError = err =>
  err?.error === 'login_required' ||
  err?.error_description === 'Login required' ||
  err?.message === 'Login required'

const useProjectStore = create((set, get) => ({
  projects: [],
  archivedProjects: [],
  setProjects: projectsArray => set({ projects: projectsArray }),
  setArchivedProjects: projectsArray => set({ archivedProjects: projectsArray }),
  getProjects: () => get().projects,
  fetchProjects: async (api, query = {}, options = {}) => {
    try {
      const hasOptions = options && Object.keys(options).length > 0
      const res = hasOptions
        ? await api.getProjects(query, options)
        : await api.getProjects(query)
      set({
        projects: res.body.map(p => ({ ...p, clientId: coerceClientId(p) })),
      })
    } catch (err) {
      if (isLoginRequiredError(err)) return
      console.error('Error loading projects', err)
      throw err
    }
  },
  fetchArchivedProjects: async (api, options = {}) => {
    try {
      const hasOptions = options && Object.keys(options).length > 0
      const res = hasOptions
        ? await api.getProjects({ include_archived: true }, options)
        : await api.getProjects({ include_archived: true })
      const archived = res.body.filter(p => p.archived_at)
      set({
        archivedProjects: archived.map(p => ({
          ...p,
          clientId: coerceClientId(p),
        })),
      })
    } catch (err) {
      if (isLoginRequiredError(err)) return
      console.error('Error loading projects', err)
      throw err
    }
  }
}))

export default useProjectStore
